/* eslint-disable @typescript-eslint/ban-types */
import { Directive, Input, Host, TemplateRef, ViewContainerRef, OnInit, DoCheck } from '@angular/core';
import { NgSwitch } from '@angular/common';

@Directive({
    selector: '[rangeSwitchCase]',
    standalone: false
})
export class RangeSwitchCaseDirective implements OnInit, DoCheck {

    @Input('rangeSwitchCase') rangeSwitchCase: any[];

    private ngSwitch: any;
    private _created = false;

    constructor(
        private viewContainer: ViewContainerRef,
        private templateRef: TemplateRef<Object>,
        @Host() ngSwitch: NgSwitch
    ) {
        this.ngSwitch = ngSwitch;
    }

    ngOnInit(): void {
        (this.rangeSwitchCase || []).forEach(() => this.ngSwitch._addCase());
    }

    ngDoCheck(): void {
        let enforce = false;
        (this.rangeSwitchCase || []).forEach(value => enforce = this.ngSwitch._matchCase(value) || enforce);
        this.enforceState(enforce);
    }

    enforceState(created: boolean): void {
        if (created && !this._created) {
            this._created = true;
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else if (!created && this._created) {
            this._created = false;
            this.viewContainer.clear();
        }
    }
}
